module.exports = __webpack_public_path__ + "assets/img/applist.09d696ea.png";